export default "__VITE_ASSET__caa30b89__"